import { useState } from "react";
import {User} from "../../services/UsersService";
import {get as httpGet, post as httpPost} from "../../services/BackendService";
import {RequireTier} from "../auth/RequireTier";

interface SsoTabProps{
  readonly user: User;
}

// Roles selectable as an SSO realm default. Mirrors the canonical UserRole list in
// packages/prerender-shared, kept local because that package's main entry pulls in node:crypto
// (via hashing-utils), which webpack 5 / CRA cannot bundle for the browser.
// 'billingManager' is intentionally omitted: a JIT-provisioned billing manager is not registered
// as a Chargebee billing contact (that only happens on invite acceptance) and would silently miss
// billing emails. Provision billing managers via the invite flow.
const SSO_DEFAULT_ROLES = ['superAdmin', 'admin', 'teamMember', 'guest'];

function download(filename: string, text: string) {
  var element = document.createElement('a');
  element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(text));
  element.setAttribute('download', filename);

  element.style.display = 'none';
  document.body.appendChild(element);

  element.click();

  document.body.removeChild(element);
}

const LoginUsersTab = (props: SsoTabProps) => {
  const {user} = props;

  const userId = user.id;

  const [error, setError]= useState(null);
  const [stage, setStage]= useState(1);

  const [domain, setDomain]= useState('');
  const [secret, setSecret]= useState('');
  const [defaultRole, setDefaultRole]= useState('');


  const generateKeycloakConfig = () => {
    setError(null);
    httpGet<string>(`/users/${userId}/keycloakrealm/config/${domain}`)
    .then( (str) => download(`${domain}_config.json`, JSON.stringify(str, null, 2)) ) // For some reason the string is parsed
    .then( () => setStage(2))
    .catch((e) => {
      setError(e.message);
      console.log(e.message)
    });
  }

  const setKeycloakConfigInTheDb = () => {
    setError(null);
    console.log('setting secret in the db')
    httpPost<string>(`/users/${userId}/keycloakrealm/db/${domain}`, {secret, defaultRole: defaultRole || undefined})
    .then( () => setStage(3))
    .catch((e) => {
      setError(e.message);
      console.log(e.message)
    });
  }

  return (<>
    <h1>
      Important: This page is not fool proof like the rest of this site. The user may already has SSO set up. 
    </h1>
    <h1>I. Generate keycloak config</h1>
    <div className="form-group">
      <label htmlFor="domain" className="form-label">
        Domain
      </label>
      <input
        type="text"
        className="form-control"
        id="domain"
        onChange={(event) => setDomain(event.target.value)}
        disabled={false}
      />
      <button className="btn btn-primary" onClick={generateKeycloakConfig} disabled={(domain.length <= 3)}>
        Generate config
      </button>
    </div>
            
    {domain && (<div>
      
    <a href="https://{domain}.app.prerender.io">
      <div>
        <span>https://{domain}.app.prerender.io</span>
      </div>
    </a>

    <a href="https://{domain}.auth.prerender.io">
    <div>
      <span>https://{domain}.auth.prerender.io</span>
    </div>
    </a>
    </div>)}

    <h1>II. Add config to the DB</h1>
    <div className="form-group">
      <label htmlFor="secret" className="form-label">
        Keycloak client credential
      </label>
      <input
        type="text"
        className="form-control"
        id="secret"
        onChange={(event) => setSecret(event.target.value)}
        disabled={false}
      />
    </div>

    <div className="form-group">
      <label htmlFor="defaultRole" className="form-label">
        Default role for JIT-provisioned SSO users (defaults to guest when left unset)
      </label>
      <select
        className="form-control"
        id="defaultRole"
        value={defaultRole}
        onChange={(event) => setDefaultRole(event.target.value)}
      >
        <option value="">(none — defaults to guest)</option>
        {SSO_DEFAULT_ROLES.map((role) => (
          <option key={role} value={role}>
            {role}
          </option>
        ))}
      </select>
      <RequireTier requiredTier="superadmin" policy="disable">
        <button className="btn btn-primary" onClick={setKeycloakConfigInTheDb} disabled={(domain.length <= 3 || !secret ||stage < 2)}>
          Set keycloak in the DB
        </button>
      </RequireTier>
    </div>

    {(stage >= 3) && <>
      <div> DONE </div>
      <div> <p>The config is added to the DB. It may take 10 minutes to be picked up by the servers. </p> </div>
      </>
    }

    {(error) && 
      (<div> ERROR: {error} </div>)
    }
  </>);
};

export default LoginUsersTab;